import ReactDOM from 'react-dom/client';
import '@shopify/polaris/build/esm/styles.css';
import * as serviceWorker from './serviceWorker';
import { BrowserRouter } from 'react-router-dom';
import { Provider } from 'react-redux'
import { store } from './redux/store'
import App from './pages/index'
import NpsModal from "./components/NpsModal";
// import reportWebVitals from './reportWebVitals'
// import ChatPlatformWilldesk from './components/ChatPlatformWilldesk'
import ChatPlatformIntercom from './components/ChatPlatformIntercom'
import utils from '../src/utils/utils';

const root = ReactDOM.createRoot(document.getElementById('root'));
utils.setupResizeObserver();
root.render(
  <Provider store={store}>
      <BrowserRouter>
        {/* 客服 - willdesk */}
        {/* <ChatPlatformWilldesk App="SEO Ant" /> */}
        {/* 客服 - intercom */}
        <ChatPlatformIntercom />
        
        {/* NPS弹窗 */}
        <NpsModal />
        
        <App />
      </BrowserRouter>
  </Provider>
);
// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
// reportWebVitals(console.log)